import { CountryInterface } from '../../models/country.interface';

export interface CountriesInterfaceState {
  list: Array<CountryInterface>;
}

export const initialCountriesState: CountriesInterfaceState = {
  list: []
};
